export default __webpack_public_path__ + "static/Corprate_WhoWeAre_04-2e4a06f0f3c60c0d3a3faade9dcc7e62.jpg";